<template>
    <div>
        <b-modal v-model="showModal" title="Share" modal-class="modal-a" hide-footer hide-header centered>
            <b-form>
                <div class="form-group" v-if="showEmail">
                    <label class="d-block">Email</label>
                    <a :href="'mailto:' + email">{{ email }}</a>
                </div>

                <div class="form-group" v-if="showPhone">
                    <label class="d-block">Phone</label>
                    <a :href="'tel:' + phone">{{ phone }}</a>
                </div>

                <!-- Subject -->
                <b-form-group
                    label="Subject"
                    label-for="subjectField"
                    :invalid-feedback="form.errors.get('subject')"
                    :state="!form.errors.has('subject')"
                    v-if="showSubject"
                >
                    <b-form-input type="text" id="subjectField" v-model="form.subject" :disabled="form.busy"></b-form-input>
                </b-form-group>

                <!-- Email -->
                <b-form-group
                    label="Email"
                    label-for="emailField"
                    :invalid-feedback="form.errors.get('from')"
                    :state="!form.errors.has('from')"
                    v-if="needEmail"
                >
                    <b-form-input type="text" id="emailField" v-model="form.from" :disabled="form.busy"></b-form-input>
                </b-form-group>

                <!-- Message -->
                <b-form-group
                    class="mb-3"
                    label="Message"
                    label-for="contentField"
                    description=""
                    :invalid-feedback="form.errors.get('message')"
                    :state="!form.errors.has('message')"
                >
                    <b-form-textarea id="contentField" v-model="form.message" placeholder="Message" :rows="5" :disabled="form.busy"></b-form-textarea>
                </b-form-group>

                <!-- Submit -->
                <b-form-group class="mb-3">
                    <button class="btn btn-secondary" @click="submit">
                        Submit
                    </button>
                    <button class="btn btn-cancel" @click="cancelModal">
                        Cancel
                    </button>
                </b-form-group>
            </b-form>
        </b-modal>
        <portal to="supportRequestModal">
            <template slot-scope="payload">
                <button :class="_get(payload, 'btnClass', 'btn btn-plain')" @click.prevent="openModal(payload)">
                    <template v-if="payload.btnTxt">
                        {{ payload.btnTxt }}
                    </template>
                    <template v-else>
                        <t-img :src="_asset('/img/helpdesk.svg')" alt="Help Desk" title="Help Desk"></t-img>
                    </template>
                </button>
            </template>
        </portal>
    </div>
</template>
<script>
export default {
    props: ['email', 'phone'],
    data() {
        return {
            showModal: false,
            showSubject: false,
            showPhone: true,
            showEmail: true,
            form: new SparkForm({
                from: '',
                subject: '',
                message: '',
                type: this.type,
                url: window.location.href,
            }),
        };
    },
    computed: {
        needEmail() {
            return !_.get(Spark, 'state.user.email');
        },
    },
    methods: {
        clearForm() {
            this.form.from = null;
            this.form.subject = null;
            this.form.message = null;
        },
        submit() {
            if (!this.needEmail) {
                this.form.from = _.get(Spark, 'state.user.email');
            }

            Spark.post('/api/contact', this.form).then(() => {
                this.showModal = false;
                this.$messenger.success('Message Sent!');
                this.form.subject = '';
                this.form.message = '';
            });
        },
        openModal(payload) {
            this.showEmail = _.get(payload, 'showEmail', true);
            this.showPhone = _.get(payload, 'showPhone', true);
            this.showSubject = _.get(payload, 'showSubject', false);
            this.form.subject = _.get(payload, 'subject', '');
            this.form.type = payload.type;
            this.showModal = true;
        },
        cancelModal() {
            this.showModal = false;
        },
    },
};
</script>
